import { render, staticRenderFns } from "./appDanmuConsoleStandalone.vue?vue&type=template&id=55eedc32&scoped=true"
import script from "./appDanmuConsoleStandalone.vue?vue&type=script&lang=js"
export * from "./appDanmuConsoleStandalone.vue?vue&type=script&lang=js"
import style0 from "./appDanmuConsoleStandalone.vue?vue&type=style&index=0&id=55eedc32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eedc32",
  null
  
)

export default component.exports